import { MenuItem } from "types/common";

export const MY_SITE_URL = window.env.REACT_APP_URL_MY_SITE;
export const HUBSHARE_URL = window.env.REACT_APP_URL_HUBSHARE;
export const DANTE_ACTIVATION_PORTAL = window.env.REACT_APP_URL_DANTE_ACTIVATION_PORTAL;
export const AUDINATE_URL = window.env.REACT_APP_URL_MY_AUDINATE;
export const OEM_URL = window.env.REACT_APP_URL_OEM;

export const NAV_DATA: MenuItem[] = [
    {
        name: "Home",
        url: `${MY_SITE_URL}/s`,
        children: null,
    },
    {
        name: "Support",
        url: null,
        children: [
            {
                name: "Cases",
                url: `${MY_SITE_URL}/s/case/Case/Default`,
                key: "cases",
            },
            {
                name: "Contact Us",
                url: `${MY_SITE_URL}/s/contact-support`,
                key: "contactUs",
            },
        ],
    },
    {
        name: "Tools",
        url: null,
        children: [
            {
                name: "Licenses",
                path: "/license",
                key: "licenseView",
            },
            {
                name: "Firmware Manager",
                path: "/firmware",
                key: "firmwareUpload",
            },
            {
                name: "Module Configuration Tool",
                url: "https://module-config.audinate.com/dnaLogin",
                key: "mcWeb",
            },
            {
                name: "Dante Activation Portal",
                url: `${DANTE_ACTIVATION_PORTAL}dnalogin`,
                key: "kothral",
            },
        ],
    },
    {
        name: "News & Events",
        url: null,
        children: [
            {
                name: "Press Releases",
                url: `${AUDINATE_URL}/press/`,
                key: "pressReleases",
            },
            {
                name: "Events",
                url: `${MY_SITE_URL}/s/events`,
                key: "events",
            },
        ],
    },
    {
        name: "Documentation & Downloads",
        url: null,
        children: [
            {
                name: "OEM Home",
                url: OEM_URL,
                newTab: true,
                key: "oemHome",
            },
            {
                name: "Your Releases",
                url: HUBSHARE_URL,
                newTab: true,
                key: "yourReleases",
            },
        ],
    },
    {
        name: "Resources",
        url: null,
        children: [
            {
                name: "Dante Updater",
                url: `${MY_SITE_URL}/s/dante-updater`,
                key: "danteUpdater",
            },
            {
                name: "Compliance",
                url: `${MY_SITE_URL}/s/documentation/compliance`,
                key: "compliance",
            },
            {
                name: "Policy & Guidelines",
                url: `${MY_SITE_URL}/s/documentation/policy-and-guidelines`,
                key: "policyAndGuidelines",
            },
            {
                name: "Special Pricing Form",
                url: `${MY_SITE_URL}/s/special-pricing-forms`,
                key: "specialPricingForm",
            },
            {
                name: "Archives",
                url: `${MY_SITE_URL}/s/archives`,
                key: "archives",
            },
        ],
    },
    {
        name: "Marketing",
        url: null,
        children: [
            {
                name: "Branding Guide",
                url: `${MY_SITE_URL}/s/dante-brand-guidelines`,
                key: "brandingGuide",
            },
            {
                name: "Logo",
                url: `${MY_SITE_URL}/s/logos`,
                key: "logo",
            },
            {
                name: "Training",
                url: `${MY_SITE_URL}/s/training`,
                key: "training",
            },
            {
                name: "Webforms",
                url: `${MY_SITE_URL}/s/webforms`,
                key: "webforms",
            },
            {
                name: "Marketing Kit",
                url: `${MY_SITE_URL}/s/oem-marketing-kit`,
                key: "marketingKit",
            },
        ],
    },
];

export const VALID_PATHS = [
    "/", "/firmware", "/license", "/user", "/user/onboarding",
    "/coming-soon", "/404", "/restricted", "/logout",
    "/auto-logout", "/accept", "/welcome"
];

/**
 * Roles that should be redirected to the home page of the Salesforce app by default.
 * This can be extended to include additional roles in the future as needed.
 */
export const HOME_PAGE_LANDING_ROLES = ["oem_customer_marketing"];
